import { Routes } from '@angular/router';

export const bhvShellRoutes: Routes = [
  {
    path: 'bhv',
    loadComponent: () =>
      import('./pages/bhv-overview/bhv-overview').then((module) => module.BhvOverview),
    data: { titleKey: 'routes.bhv' },
  },
];
